import {
    FETCH_UPDATE_WASTE_REQUEST,
    FETCH_UPDATE_WASTE_SUCCESS,
    FETCH_UPDATE_WASTE_FALUIRE
} from './updateWasteTypes';

const initialState = {
    loading: false,
    updateWaste: {},
    error: '',
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_UPDATE_WASTE_REQUEST:
            return {
                ...state,
                loading: true,
            };


        case FETCH_UPDATE_WASTE_SUCCESS:
            return {
                ...state,
                updateWaste: action.payload,
                error: '',
                loading: false,
            };

        case FETCH_UPDATE_WASTE_FALUIRE:
            return {
                ...state,
                loading: false,
                updateWaste: null,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
